var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightSwoosh = function SvgRightSwoosh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 258,
    fill: "none",
    viewBox: "0 0 140 258"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.5 123H0v135h140v-8c0-105-82-127-133.5-127"
  })));
};
export { SvgRightSwoosh as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQwIiBoZWlnaHQ9IjI1OCIgdmlld0JveD0iMCAwIDE0MCAyNTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTYuNSAxMjNIMHYxMzVoMTQwdi04YzAtMTA1LTgyLTEyNy0xMzMuNS0xMjd6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+";